import $ from "jquery";

// Insert your costum JS

class Menu {
    run() {
        this.toggleMenu();
    }

    toggleMenu() {
        const header = $('header');
        const mainMenu = $('#main-menu');
        const menuToggler = $('#menu-toggler');

        menuToggler.on('click', function(){
            header.toggleClass('active');
        });

        if ($('[data-component="hero"]').length > 0) {
            // console.log("found hero!");
            $(window).scroll(function () {
                let nav = $('.navbar');
                let hero = $('[data-component="hero"]');
                let nav_pos = nav.offset().top;
                let hero_pos = hero.height() + hero.offset().top;
                if (nav_pos > hero_pos) {
                    $('.navbar').addClass('navbar-dark');
                } else {
                    $('.navbar').removeClass('navbar-dark');
                }
            });
        } else {
            //console.log("hero not found! Changing navbar to dark.");
            $('.navbar').addClass('navbar-dark');
        }

    }
}

const menu = new Menu();
export default menu;
